<template lang="html">
  <div class="">

    <div class="select_question select_question-red container align-items-stretch watch-select-timer">
      <div class="img container align-center">
        <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
      </div>
      <div class="flex-grow-1 bordered-box bordered-box-orange">
        <p>{{ question.question }}</p>
      </div>

      <button class="btn btn-rounded btn-green color-white gradient-green"
              :class="{ disabled : question.answered}"
              :disabled="question.answered || answering || ended"
              @click="startTimer()">
        START TIME
      </button>

      <div class="container align-center timer-icon">
        <img src="@/assets/img/conquistas/svg/4.svg" width="30" alt="Minds" class="">
        <div class="container column align-center container-timer">
          <b>{{ time }}</b>
          <div class="progress">
            <div class="progress-status" ref="progressBar" :style="{ animationPlayState: answering ? 'running' : 'paused', animationDuration: `${question.timer}s` }">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="select-question select-question_answer-select-question container">

      <div class="select-question__left flex-grow-1 flex-basis-600">
        <div class="animation-bottom">
          <VideoPlayer ref="player" :exercise="exercise" />
        </div>
      </div>

      <div class="select-question__right flex-grow-2 flex-basis-500">
        <ul class="list-none relative">
          <div class="block__game" v-if="ended"></div>
          <li v-for="(x, ind) in question.answers" class="animation-bottom" :style="{animationDelay: (ind / 20) + 's'}" :key="ind">
            <div class="select-question__item container align-items-center" @click="selectQuestion(x)" :class="{ correct : question.answered && x.correct, wrong: question.answered && !x.correct && x.selected, clicked: x.selected}"
              ref="options">
              <div class="index">
                {{ind + 1}}
              </div>
              {{x.text}}
            </div>
          </li>
        </ul>
      </div>

    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback" />
        </transition>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose" />
    </modal>
  </div>
</template>

<script>
import VideoPlayer from "./GameComponents/VideoPlayer";
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { mapGetters } from "vuex";

export default {
  components: {
    gameFeedback,
    modal,
    modalSubTopic,
    VideoPlayer
  },
  data() {
    return {
      showFeedback: false,
      question: {},
      ended: false,
      index: 0,
      showInfo: false,
      oldTime: null,
      currentTime: null,
      playing: false,
      first: true,
      answering: false,
      time: 0,
      interval: null
    };
  },
  props: {
    topic: {
      type: Object,
      default: () => new Object()
    },
    subTopic: {
      type: Object,
      default: () => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise () {
      return this.subTopic.exercise
    }
  },
  methods: {
    async selectQuestion(answer) {
      if (!this.question.answered && this.answering) {
        answer.selected = true;
        this.question.answered = true;
        if (answer.correct) this.question.hit = true;
        else this.question.hit = false;
        this.$set(this.exercise.questions, this.index, this.question);
        this.feedback();
        clearInterval(this.interval);
        this.answering = false;
        await this.save(this.question);
      }
    },
    async feedback() {
      this.showFeedback = true;
      await this.$delay(1500);
      this.showFeedback = false;
      gameBus.$emit("setEnabled", true);
    },
    verify(question) {
      if (question.answers) {
        const correctIndex = question.answers.findIndex(x => x.correct);
        if (question.answers[correctIndex].selected) return true;
      }
      return false;
    },
    async setCurrent() {
      let qst = {},
          currentIndex = 0;
      const questions = this.exercise.questions;
      for (const index in questions) {
        currentIndex = index;
        if (!questions[index].answered) {
          qst = questions[index];
          this.answering = false;
          break;
        } else if (parseInt(index) == questions.length - 1) {
          qst = questions[index];
          this.ended = true;
        }
      }
      this.index = currentIndex
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        if (!this.ended) {
          this.time = qst.timer
        }
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
        this.$refs['progressBar'].classList.remove('timer-progress')
        setTimeout(() => {
          this.$refs['progressBar'].classList.add('timer-progress')
        }, 500)
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    async save(question) {
      let scoreQuestions = 0,
          answered       = 0

      for (const qst of this.exercise.questions) {
        for (const aswr of qst.answers) {
          if (aswr.selected && aswr.correct) scoreQuestions++;
        }
        if (qst.answered) answered++
      }

      const score = (scoreQuestions * 100)/this.exercise.questions.length
      let payload = {
        points: score,
        finished: false,
        question: { ...question }
      }

      if (answered == this.exercise.questions.length) {
        payload.finished = true
        this.ended = true
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit('updateProgress', score)

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch('subTopic/answerQuestion', payload)
    },
    startTimer () {
      if (!this.answering && !this.question.answered) {
        this.answering = true
        this.interval = setInterval(async () => {
          this.time--
          if (this.time == 0) {
            clearInterval(this.interval)
            this.$set(this.question, 'answered', true)
            this.$set(this.question, 'hit', false)
            this.feedback()
            await this.save(this.question)
            this.answering = false
          }
        }, 1000)
      }
    },
    next () {
      if (!this.answering) {
        this.setCurrent()
      }
    },
    closeModal () {
      this.showInfo = false
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    async viewQuestion (index) {
      const question = this.exercise.questions[index]
      if (question && question.answered) {
        this.index = index
        this.$set(this, 'question', question)
      }
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  async mounted() {
    this.setCurrent();
    gameBus.$emit("updateProgress", this.subTopic.points);
    modalBus.$on("close", this.closeModal);
    gameBus.$on("viewQuestion", this.viewQuestion);
    gameBus.$on("setCurrent", this.next);
  },
  beforeDestroy() {
    modalBus.$off("close", this.closeModal);
    gameBus.$off("viewQuestion", this.viewQuestion);
    gameBus.$off("setCurrent", this.next);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";

.timer {
  &-icon {
    padding: 10px;
    width: auto;
    box-sizing: border-box;
    border-radius: 10px;
    background: #ff9c00;
    color: #c2003c;
    img {
      width: 30px;
      margin-right: 10px;
    }

    .progress {
      width: 80px;
      background: #fff;
      height: 10px;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      &-status {
        width: 0%;
        height: 10px;
        position: absolute;
        left: 0;
        top: 0;
        background: #c2003c;
      }
    }
  }
  &-text {
    font-size: 20px;
  }
}

.watch-select-timer {
  .btn {
    margin: 0 10px;
  }
}

.btn-start {
  cursor: pointer !important;
}

.timer-progress {
  animation-name: timeProgress;
  animation-fill-mode: backwards;
  animation-timing-function: linear;
}

@keyframes timeProgress {
  from { width: 100%; }
  to { width: 0%; }
}
</style>



// WEBPACK FOOTER //
// src/components/game/watchSelectTimer.vue